import { Component, effect, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeroComponent } from "@shared/component/hero/hero.component";
import { UserApiService } from '@shared/services/users/userApi.service';

@Component({
	selector: 'app-verify-consents',
	imports: [TranslateModule, HeroComponent],
	templateUrl: './verify-consents.component.html',
	styleUrl: './verify-consents.component.scss',
})
export class VerifyConsentsComponent {
	private userApi = inject(UserApiService);
	protected id = input<string>();
	protected tag = input<string>();

	protected outcome: boolean;
	protected wrongPrameters = false;
	constructor() {
		effect(() => {
			const hash = this.tag(),
				id = Number(this.id()!); // NOTE: "! just to keep Typescript quiet. In case, Number would return NaN
			if (hash && id && !isNaN(id)) {
				this.userApi.verifyConsentsUsingPOST({ hash, id })
					.subscribe({
						next: () => { this.outcome = true; },
						error: () => { this.outcome = false; }
					});
			} else {
				this.wrongPrameters = true; this.outcome = false;
			}
		});
	}
}